import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { addRegisteredSectionLayout } from "../../sectionLayoutDescriptions";
import { Grid, makeStyles, Typography, Checkbox, Button, Tooltip } from "@material-ui/core";
import { useDebounce } from "use-debounce";
import { DployAutocomplete, DployFormControl } from "@ploy-ui/form-fields";
import { CustomerResource, CustomerChildrenResource } from "@ploy-lib/rest-resources";
import { FormattedMessage, useIntl } from "react-intl";
import { useFetcher } from "@rest-hooks/core";
import { useStatefulResource } from "@rest-hooks/legacy";
import { useDispatch, useVariableData } from "@ploy-lib/calculation";
import clsx from "clsx";
import { Delete } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { GroupInformation } from "./GroupInformation";
import { PendingButton } from "@ploy-ui/core";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import HelpIcon from "@material-ui/icons/Help";
import { createValidationHelpers } from "@ploy-lib/validation-helpers";
addRegisteredSectionLayout({
    name: "LimitCustomersSection",
    displayName: "LimitCustomersSection",
    settings: {}
});
const useStyles = makeStyles(theme => ({
    header: {
        fontSize: 12,
        fontWeight: "bold"
    },
    customerName: {
        paddingLeft: 2
    },
    customerHeader: {
        paddingLeft: 2
    },
    mainCustomerName: {
        fontWeight: "bold"
    },
    deleteIcon: {
        fontSize: 20,
        "&:hover": {
            cursor: "pointer"
        }
    },
    checkboxes: {
        padding: 2
    },
    saveButton: {
        marginTop: 5
    },
    lowContrastText: {
        color: theme.palette.text.disabled
    },
    centerText: {
        textAlign: "center"
    }
}));
export const useModalStyles = makeStyles(theme => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    card: {
        flexBasis: 1000,
        maxHeight: "100vh",
        overflowY: "auto"
    },
    buttonContainer: {
        textAlign: "right"
    },
    button: {
        margin: 5
    }
}));
const LimitCustomersSection = (props) => {
    return _jsx(LimitCustomersCalcRulesWrapper, { ...props });
};
const LimitCustomersCalcRulesWrapper = (props) => {
    const dispatch = useDispatch();
    const limitCustomersVariable = useVariableData("Calculator", "LIMIT_CUSTOMERS");
    const limitCustomers = limitCustomersVariable.value || [];
    const addLimitCustomers = (newLimitCustomers) => dispatch({
        type: "patch",
        payload: {
            patches: [
                {
                    target: "LIMIT_CUSTOMERS",
                    namespace: "Calculator",
                    value: [...limitCustomers, ...newLimitCustomers],
                    overwrite: true
                }
            ]
        }
    });
    const updateLimitCustomer = (limitCustomer) => {
        var newLimitCustomers = limitCustomers.map(c => {
            if (c.customerId === limitCustomer.customerId)
                return limitCustomer;
            return c;
        });
        dispatch({
            type: "patch",
            payload: {
                patches: [
                    {
                        target: "LIMIT_CUSTOMERS",
                        namespace: "Calculator",
                        value: newLimitCustomers,
                        overwrite: true
                    }
                ]
            }
        });
    };
    const deleteLimitCustomer = (limitCustomer) => {
        dispatch({
            type: "patch",
            payload: {
                patches: [
                    {
                        target: "LIMIT_CUSTOMERS",
                        namespace: "Calculator",
                        value: limitCustomers.filter(c => c.customerId !== limitCustomer.customerId),
                        overwrite: true
                    }
                ]
            }
        });
    };
    return (_jsx(InnerLimitCustomersSection, { ...props, limitCustomers: limitCustomers, addLimitCustomers: addLimitCustomers, updateLimitCustomer: updateLimitCustomer, deleteLimitCustomer: deleteLimitCustomer }));
};
const InnerLimitCustomersSection = (props) => {
    const { limitCustomers, addLimitCustomers, updateLimitCustomer, deleteLimitCustomer, literal, className, onClick, collapsedSection } = props;
    const classes = useStyles();
    const intl = useIntl();
    const [touched, setTouched] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchString] = useDebounce(searchValue, 350);
    const [clickSearchPending, setClickSearchPending] = useState(false);
    const [newChildIds, setNewChildIds] = useState([]);
    const validation = createValidationHelpers(intl);
    const mainCustomer = limitCustomers.length > 0 ? limitCustomers[0] : {};
    const { data: searchedCustomers, loading } = useStatefulResource(CustomerResource.list(), searchString && searchString.length > 2
        ? {
            data: searchString
        }
        : null);
    const { data: customerChildren } = useStatefulResource(CustomerChildrenResource.detail(), mainCustomer.customerId ? { customerId: mainCustomer.customerId } : null);
    const updateChildren = useFetcher(CustomerChildrenResource.update());
    return (_jsxs(Grid, { container: true, className: className, onClick: onClick, spacing: 0, "data-cr-field": "LimitCustomersSection", children: [literal ? null : (_jsx(_Fragment, { children: _jsxs(Grid, { item: true, container: true, xs: 12, children: [_jsx(Grid, { item: true, xs: 7, children: _jsx(DployFormControl, { fullWidth: true, margin: "normal", children: _jsx(DployAutocomplete, { "data-cr-field": "LimitCustomerNumber", "data-cr-component": "BisnodeSearch", label: _jsx(FormattedMessage, { id: `limit-customers-section.limitCustomer.searchField.label`, description: "Label for searchfield", defaultMessage: "Org.nr" }), placeholder: intl.formatMessage({
                                        id: `limit-customers-section.limitCustomer.searchField.placeholder`,
                                        description: "Placeholder for searchfield",
                                        defaultMessage: "Organisasjonsnr. (9 siffer)"
                                    }), disabled: mainCustomer == null || literal, variant: "input", pending: loading, items: searchedCustomers?.filter(c => !limitCustomers.find(f => f.customerId === c.customerId)) || [], getItemLabel: item => item.value, inputValue: searchValue, onInputChange: (e, value) => {
                                        if (e && e.type === "change") {
                                            if (Number(value.replace(/\s/g, ""))) {
                                                setSearchValue(value.replace(/\s/g, ""));
                                            }
                                            else {
                                                setSearchValue(value);
                                            }
                                        }
                                    }, onChange: (e, customer) => {
                                        setSearchValue("");
                                        addLimitCustomers([
                                            {
                                                customerId: customer.customerId,
                                                customerName: customer.value || ""
                                            }
                                        ]);
                                    }, searchable: true, disableClearable: true, error: touched &&
                                        searchValue.length > 0 &&
                                        !validation.validOrgNumber(searchValue), helperText: touched &&
                                        searchValue.length > 0 &&
                                        !validation.validOrgNumber(searchValue)
                                        ? intl.formatMessage({
                                            id: "limit-customer-section.limitCustomer.searchField.Errormessage",
                                            description: "Errormessage for searchfield",
                                            defaultMessage: "Organisasjonsnummer må bestå av 9 siffer"
                                        })
                                        : "", onBlur: () => setTouched(true) }, "competition-selector") }) }), _jsxs(Grid, { item: true, xs: 5, children: [_jsx(DployFormControl, { id: "CustomerNumberSearchButton", margin: "normal", children: _jsx(PendingButton, { disabled: literal, pending: clickSearchPending, variant: "outlined", color: "secondary", style: { marginTop: -3 }, size: "large", onClick: () => {
                                            if (!searchValue)
                                                return;
                                            setClickSearchPending(true);
                                            fetch(legacyApiResourceUrl(`/CustomerSearchJson/SearchForCustomer?identifier=${searchValue}`), { method: "GET" })
                                                .then(res => res.json())
                                                .then(res => {
                                                if (res[0].CustomerId) {
                                                    setSearchValue("");
                                                    if (limitCustomers
                                                        .map(x => x.customerName)
                                                        .includes(res[0].CustomerName)) {
                                                        return;
                                                    }
                                                    addLimitCustomers([
                                                        {
                                                            customerId: res[0].CustomerId,
                                                            customerName: res[0].CustomerName
                                                        }
                                                    ]);
                                                }
                                            })
                                                .finally(() => {
                                                setClickSearchPending(false);
                                            });
                                        }, success: false, children: _jsx(SearchIcon, {}) }) }), _jsx(GroupInformation, { customerId: mainCustomer.customerId, limitCustomers: limitCustomers, addLimitCustomers: addLimitCustomers, customerSearchPending: clickSearchPending, disabled: literal })] })] }) })), _jsxs(Grid, { item: true, xs: 12, container: true, children: [_jsx(Grid, { item: true, xs: 6, children: _jsx(Typography, { variant: "h6", className: clsx(classes.header, classes.customerHeader, {
                                [classes.lowContrastText]: collapsedSection
                            }), children: _jsx(FormattedMessage, { id: `limit-customers-section.limitCustomer.customerName`, description: "Choosen company", defaultMessage: "Valgte selskap" }) }) }), _jsx(Grid, { item: true, xs: 2, children: _jsx(Typography, { align: "center", variant: "h6", className: clsx(classes.header, classes.centerText, {
                                [classes.lowContrastText]: collapsedSection
                            }), children: _jsx(FormattedMessage, { id: `limit-customers-section.limitCustomer.canDrawFromMainLimit`, description: "Can company draw from main limit", defaultMessage: "Hovedramme" }) }) }), collapsedSection ? null : (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 2, children: _jsx(Typography, { align: "center", variant: "h6", className: clsx(classes.header, classes.centerText, {
                                        [classes.lowContrastText]: collapsedSection
                                    }), children: _jsx(FormattedMessage, { id: `limit-customers-section.limitCustomer.childCompany`, description: "Child company", defaultMessage: "Underselskap" }) }) }), _jsx(Grid, { item: true, xs: 2, style: { textAlign: "center" }, children: _jsx(Tooltip, { title: _jsxs(Typography, { align: "center", variant: "body2", children: ["Hovedramme: Selskapet kan trekke p\u00E5 hovedramme", _jsx("br", {}), "Underselskap: Selskapet er underselskap av hovedkunden"] }), children: _jsx(HelpIcon, {}) }) })] })), limitCustomers?.map((row, index) => (_jsxs(Grid, { item: true, xs: 12, container: true, spacing: 0, alignItems: "center", children: [_jsx(Grid, { item: true, xs: 6, children: _jsx(Typography, { className: clsx(classes.customerName, {
                                        [classes.mainCustomerName]: row.customerId === mainCustomer.customerId,
                                        [classes.lowContrastText]: collapsedSection
                                    }), children: row.customerName }) }), _jsx(Grid, { item: true, xs: 2, className: classes.centerText, children: _jsx(Checkbox, { className: classes.checkboxes, "data-cr-field": "LimitCustomersCheckboxMainLimit_" + row.customerName, id: row.customerId?.toString() + row.customerName, checked: row.canDrawFromMainLimit ||
                                        row.customerId === mainCustomer.customerId, disabled: row.customerId === mainCustomer.customerId || literal, onClick: () => {
                                        updateLimitCustomer({
                                            ...row,
                                            canDrawFromMainLimit: !row.canDrawFromMainLimit
                                        });
                                    } }) }), collapsedSection ? null : (_jsx(Grid, { item: true, xs: 2, className: classes.centerText, children: row.customerId === mainCustomer.customerId ? null : (_jsx(Checkbox, { className: classes.checkboxes, "data-cr-field": "LimitCustomersCheckboxSubsidiary_" + row.customerName, checked: customerChildren?.childList?.includes(row.customerId) ||
                                        customerChildren?.recursiveChildList?.includes(row.customerId) ||
                                        newChildIds.includes(row.customerId) ||
                                        false, disabled: literal ||
                                        row.customerId === mainCustomer.customerId ||
                                        customerChildren?.childList?.includes(row.customerId) ||
                                        customerChildren?.recursiveChildList?.includes(row.customerId) ||
                                        false, 
                                    //TODO: Different color if recursive child
                                    onClick: () => {
                                        if (!newChildIds.includes(row.customerId))
                                            setNewChildIds([...newChildIds, row.customerId]);
                                        else
                                            setNewChildIds([
                                                ...newChildIds.filter(id => id !== row.customerId)
                                            ]);
                                    } })) })), _jsx(Grid, { item: true, xs: 2, className: classes.centerText, children: literal || row.customerId === mainCustomer.customerId ? null : (_jsx(Delete, { className: classes.deleteIcon, onClick: () => deleteLimitCustomer(row) })) })] }, row.customerId)))] }), literal ? null : (_jsxs(Grid, { container: true, item: true, xs: 12, children: [_jsx(Grid, { item: true, xs: 7 }), _jsx(Grid, { item: true, xs: 5, children: _jsx(DployFormControl, { children: _jsx(Button, { className: classes.saveButton, color: "secondary", size: "large", disabled: literal, variant: "outlined", onClick: () => updateChildren({}, {
                                    customerId: customerChildren.customerId,
                                    newChildIds: newChildIds
                                }), children: _jsx(Typography, { children: _jsx(FormattedMessage, { id: `limit-customers-section.saveButton`, description: "Save customer group button text", defaultMessage: "Oppdater kundekort" }) }) }) }) })] }))] }));
};
LimitCustomersSection.displayName = "LimitCustomersSection";
export { LimitCustomersSection };
//# sourceMappingURL=LimitCustomersSection.js.map